import { useEffect } from 'react'
import { instrumenter } from '~/app/utils/instrumentation'
import { useExperimentation } from '~/app/features/Gallery/hooks/useExperimentation'
import { experimentVariation, NOTECARDS_PDP_FLOW_TEST_EXPERIMENT_NAME } from '~/shared/experiments/constants'

export const useInitExperiments = (): void => {
  const isExperimentActive = useExperimentation()

  useEffect(() => {
    // Fire experiment impression event for server side experiments
    instrumenter.recordAppHydratedEvent()
    isExperimentActive(experimentVariation[NOTECARDS_PDP_FLOW_TEST_EXPERIMENT_NAME].Control)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
